/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiClassEnrollmentsRecentStatusChangesGetDaysParameter
 */
export interface ApiClassEnrollmentsRecentStatusChangesGetDaysParameter {
}

/**
 * Check if a given object implements the ApiClassEnrollmentsRecentStatusChangesGetDaysParameter interface.
 */
export function instanceOfApiClassEnrollmentsRecentStatusChangesGetDaysParameter(value: object): value is ApiClassEnrollmentsRecentStatusChangesGetDaysParameter {
    return true;
}

export function ApiClassEnrollmentsRecentStatusChangesGetDaysParameterFromJSON(json: any): ApiClassEnrollmentsRecentStatusChangesGetDaysParameter {
    return ApiClassEnrollmentsRecentStatusChangesGetDaysParameterFromJSONTyped(json, false);
}

export function ApiClassEnrollmentsRecentStatusChangesGetDaysParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiClassEnrollmentsRecentStatusChangesGetDaysParameter {
    return json;
}

export function ApiClassEnrollmentsRecentStatusChangesGetDaysParameterToJSON(json: any): ApiClassEnrollmentsRecentStatusChangesGetDaysParameter {
    return ApiClassEnrollmentsRecentStatusChangesGetDaysParameterToJSONTyped(json, false);
}

export function ApiClassEnrollmentsRecentStatusChangesGetDaysParameterToJSONTyped(value?: ApiClassEnrollmentsRecentStatusChangesGetDaysParameter | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

